export let NOTIFICATION_TRACKER_NAMES;
(function (NOTIFICATION_TRACKER_NAMES) {
  NOTIFICATION_TRACKER_NAMES["NOTIFICATION_INTERACTION"] = "notificationInteraction";
  NOTIFICATION_TRACKER_NAMES["NOTIFICATION_USAGE"] = "notificationUsage";
  NOTIFICATION_TRACKER_NAMES["BROWSER_NOTIFICATIONS_INTERACTION"] = "browserNotificationsInteraction";
  NOTIFICATION_TRACKER_NAMES["SIDEBAR_NOTIFICATION_INTERACTION"] = "sidebarNotificationInteraction";
})(NOTIFICATION_TRACKER_NAMES || (NOTIFICATION_TRACKER_NAMES = {}));
export let SIDEBAR_TRACKER_NAMES;
(function (SIDEBAR_TRACKER_NAMES) {
  SIDEBAR_TRACKER_NAMES["NOTIFICATION_SIDEBAR_INTERACTION"] = "SidebarInteraction";
})(SIDEBAR_TRACKER_NAMES || (SIDEBAR_TRACKER_NAMES = {}));